module.exports = __webpack_public_path__ + "img/google-play-badge.ccc167a8.png";